import React, { useState, useEffect } from 'react';
import styles from './MediaCard.module.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faClapperboardPlay,
  faPlay,
  faFilePdf
} from '@fortawesome/pro-duotone-svg-icons';
import ProgressBar from 'react-bootstrap/ProgressBar';
import toast from 'react-hot-toast';
import { useTranslate } from '@tolgee/react';
import { useDispatch, useSelector } from 'react-redux';

import { externalContentRootState } from '../../../../pages/externalContent';
import { PLATFORM_STATIC_ICONS } from '../../../../config/icons';
import ImageWithLoading from '../commonElements/imageWithLoading';

interface Props {
  item: any;
  setUploadCount: React.Dispatch<React.SetStateAction<number>>;
  setTotalUploadCount: React.Dispatch<React.SetStateAction<number>>;
}
interface MediaObject {
  uploaded: boolean;
  id: string;

  // Other properties...
}

const TempMediaCard: React.FC<Props> = ({
  item,
  setUploadCount,

  setTotalUploadCount
}) => {
  const [imageError, setImageError] = useState(false);
  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);

  return (
    <div
      style={{ position: 'relative' }}
      className={`${styles['image-container']} d-flex justify-content-center align-items-center`}
    >
      {item.media_type === 'video' && (
        <div
          style={{
            position: 'absolute',
            borderRadius: '2px',
            top: '10px',
            right: '13px'
          }}
        >
          <i
            className="fas fa-play"
            style={{ color: '#ffffff', fontSize: '1.25em' }}
          ></i>
        </div>
      )}

      <div
        className="w-100 position-absolute top-50 start-50 d-flex justify-content-center align-items-center"
        style={{
          alignItems: 'center',
          zIndex: 10,
          transform: 'translate(-50%, -50%)'
        }}
      >
        <div
          style={{
            aspectRatio: 1,
            alignItems: 'center',
            zIndex: 10
          }}
          className="d-flex justify-content-center align-item-center rounded w-50px h-100"
        >
          <span
            className="spinner-border spinner-border-sm text-muted w-100 h-100"
            role="status"
            aria-hidden="true"
          ></span>
        </div>
      </div>

      {uploading && (
        <div
          style={{
            width: '75%',
            position: 'absolute',
            borderRadius: '2px',
            bottom: '10px',
            margin: '0 auto 0 auto',
            zIndex: 9
          }}
        >
          <ProgressBar striped variant="primary" animated now={progress} />
        </div>
      )}

      {!imageError && item.preview_image && item.media_type !== 'doc' ? (
        <div
          className={`h-100 w-100 bg-white d-flex justify-content-center align-items-center m-1`}
        >
          <ImageWithLoading
            src={item.preview_image ? item.preview_image : item.thumbnail_image}
            alt="placeholder"
            className={'img-thumbnail m-1 h-100px w-100px'}
            style={{ objectFit: 'cover', imageOrientation: 'from-image' }}
            fallbackText=""
          />
        </div>
      ) : item.media_type === 'video' ? (
        <div
          className={`${styles['empty-state']} h-100px w-100px bg-dark bg-opacity-25 d-flex justify-content-center align-items-center border border-white border-3 rounded-2 m-1`}
        >
          <img
            className=""
            style={{ width: '50%', height: '50%' }}
            src={PLATFORM_STATIC_ICONS.video_placeholder}
          />
        </div>
      ) : item.media_type === 'doc' ? (
        <div
          className={
            'm-1 h-100px w-100px d-flex flex-column border justify-content-center align-items-center p-5 bg-white'
          }
        >
          <i
            style={{ fontSize: '70px', height: '70px' }}
            className="fa-duotone fa-file-pdf text-danger "
          ></i>
        </div>
      ) : (
        <div
          className={
            'm-1 h-100px w-100px d-flex flex-column border justify-content-center align-items-center p-5 bg-white'
          }
        >
          <i
            style={{ fontSize: '70px', height: '70px' }}
            className="fa-duotone fa-solid fa-file text-primary"
          ></i>
        </div>
      )}
    </div>
  );
};

export default TempMediaCard;
